import React, { useState } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'

import {
  FormControl,
  IconButton,
  TextField,
  InputAdornment,
  InputLabel,
  Input,
  FormHelperText,
  Box,
} from '@mui/material'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft'
import EventIcon from '@mui/icons-material/Event'
import { RootComponant } from './Styles'

const YEARS = () => {
  const years = []
  const dateStart = moment().year(1940)
  const dateEnd = moment()
  while (dateEnd.diff(dateStart, 'years') >= 0) {
    years.push(dateStart.format('YYYY'))
    dateStart.add(1, 'year')
  }
  return years
}

const InputCustom = ({ onClick, value, error, inputRef, label, placeholder, ...rest }) => {
  // console.log('InputCustom', { ...rest })
  // console.log('inputRef', inputRef)
  return (
    <FormControl error={error ? true : false} variant="standard" fullWidth>
      <InputLabel htmlFor="standard-adornment-password">{label}</InputLabel>
      <Input
        {...rest}
        inputRef={inputRef}
        value={value && moment(value).format('DD/MM/YYYY')}
        placeholder="dd/mm/yyyy"
        id="standard-adornment-password"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle"
              onClick={onClick}
              // onMouseDown={handleMouseDownPassword}
            >
              <EventIcon />
            </IconButton>
          </InputAdornment>
        }
        fullWidth
      />
      {error && <FormHelperText id="component-error-text">{error.message}</FormHelperText>}
    </FormControl>
  )
}

function DatepickerComponant({
  inputRef,
  error,
  helperText,
  onChange,
  value,
  maxDate,
  minDate,
  fullWidth,
  placeholder,
  ...rest
}) {
  const [startDate, setStartDate] = useState(new Date())
  const years = YEARS()
  const handleChange = (date) => {
    // setStartDate
    onChange(moment(date).format('DD/MM/YYYY'))
    // onChange(date)
  }
  // console.log(YEARS())
  return (
    <RootComponant>
      <FormControl fullWidth>
        <DatePicker
          {...rest}
          selected={value && new Date(moment(value, 'DD/MM/YYYY'))}
          onChange={handleChange}
          minDate={minDate && new Date(moment(minDate, 'DD/MM/YYYY'))}
          maxDate={maxDate && new Date(moment(maxDate, 'DD/MM/YYYY'))}
          customInput={
            <InputCustom {...rest} error={error} helperText={helperText} inputRef={inputRef} />
          }
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
          }) => {
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="headerRoot">
                  <IconButton className={'headerButton'} size="small" onClick={decreaseMonth}>
                    <ArrowCircleLeftIcon />
                  </IconButton>
                  <div className="react-datepicker__current-month">
                    {moment(date).format('MMMM YYYY')}
                  </div>
                  <div>
                    <IconButton className={'headerButton'} size="small" onClick={increaseMonth}>
                      <ArrowCircleRightIcon />
                    </IconButton>
                  </div>
                </div>
                <select
                  value={moment(date).format('YYYY')}
                  onChange={({ target: { value } }) => changeYear(value)}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #4aa6c5',
                    borderRadius: '16px',
                    padding: '4px',
                  }}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </Box>
            )
          }}
        />
      </FormControl>
    </RootComponant>
  )
}

export default DatepickerComponant
